import { authRoutes } from './authRoutes';
import { publicRoutes } from './publicRoutes';
import { userRoutes } from './userRoutes';
import { companyRoutes } from './companyRoutes';

/**
 * Índice centralizado de todas las rutas de la aplicación
 * 
 * Estructura:
 * - authOnlyRoutes: Rutas de autenticación (sin Layout, solo no autenticados)
 * - protectedRoutes: Rutas que requieren autenticación (con Layout)
 * - publicRoutes: Rutas públicas (con Layout, accesibles por todos)
 */

// Rutas de autenticación (sin Layout, solo no autenticados)
export const authOnlyRoutes = authRoutes;

// Rutas protegidas combinadas (usuarios + empresas)
export const protectedRoutes = [
    ...userRoutes,
    ...companyRoutes
];

// Rutas públicas (con Layout, todos pueden acceder)
export { publicRoutes };

// Todas las rutas para referencia
export const allRoutes = [
    ...authOnlyRoutes,
    ...protectedRoutes,
    ...publicRoutes
];

// Exportaciones nombradas individuales para uso específico
export { authRoutes, userRoutes, companyRoutes };
